/**
 * URL Building Utilities
 * Handles construction of full URLs for API requests
 */

import { API_VERSION_REGEX } from "./constants";
import type { ApiConfig } from "./types";

export function isNextJSRoute(path: string, config: ApiConfig): boolean {
  return path.startsWith(config.nextjs.proxyPrefix);
}

export function buildFullURL(
  path: string,
  isClient: boolean,
  config: ApiConfig,
): string {
  if (isNextJSRoute(path, config)) {
    return isClient
      ? `${window.location.origin}${path}`
      : `${config.nextjs.serverUrl}${path}`;
  }

  const cleanPath = path.replace(/^\//, "");

  // Path already includes version (api/v1/, api/v2/, etc.)
  if (API_VERSION_REGEX.test(cleanPath)) {
    return `${config.backend.baseUrl}/${cleanPath}`;
  }

  // Relative path - add default prefix
  return `${config.backend.baseUrl}${config.backend.apiPrefix}/${cleanPath}`;
}
